export enum TICKET_PRIORITY {
  CRITICAL = 'P1',
  HIGH = 'P2',
  MEDIUM = 'P3',
  LOW = 'P4',
}
